<template lang="pug">
    .event-calendar(:class="{ 'center-schedule': center }" ref="container")
        .days(v-if="days && days.length" ref="schedule")
            section.steps
                .label-placeholder
                .steps-container
                    .step(v-for="(step, i) in steps" :class="step.type" :style="getStepStyle(i)")
                        .time(v-if="step.type === 'major'") {{ step.time | formatDate('HH') }}
                        hr
                    .step.major(style="position: absolute; top: 100%;")
                        .time {{ matrix.max.time | formatTimestamp('HH') }}
                        hr
            section.slots(v-for="(day, d) in days" :class="{ empty: ! day.slots.length }")
                template(v-if="day.visible")
                    .day(v-if="day.slots.length")
                        h4 {{ day.date | formatDate }}
                        .slots
                            component.slot(
                                v-for="(el, s) in day.slots" :style="getSlotStyle(d,s)"
                                :key="el.id"
                                href="#"
                                @click.prevent.stop="toggleSlot(el)"
                                :is="event.booking !== 'none' ? 'a' : 'div'"
                                :class="getSlotClass(d,s)"
                            )
                                // :class="limit = el.member_limit || event.member_limit_per_slot; { selected: (slot && el.id === slot.id), disabled: (el.bookings.length >= limit) }
                                .member-limit(v-if="el.member_limit !== null || event.member_limit_per_slot !== null")
                                    | {{ el.bookings.length }} / {{ el.member_limit || event.member_limit_per_slot }}
                                .period {{ el.start_time | formatTimestamp('HH:mm') }} - {{ el.end_time | formatTimestamp('HH:mm') }}
                                .check(:class="slot && el.id === slot.id ? 'visible' : ''")
                                    <svg viewBox="0 0 448 512">
                                        <path fill="currentColor" d="M413.505 91.951L133.49 371.966l-98.995-98.995c-4.686-4.686-12.284-4.686-16.971 0L6.211 284.284c-4.686 4.686-4.686 12.284 0 16.971l118.794 118.794c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-11.314-11.314c-4.686-4.686-12.284-4.686-16.97 0z"></path>
                                    </svg>
                    .placeholder(v-else-if="day.placeholder") [...]
        .no-slots(v-else-if="event")
            .notification Für das ausgewählte Event gibt es keine Termine

</template>

<script>

    import _ from 'lodash'
    import Color from 'color'

    import { mapGetters, mapMutations } from 'vuex'

    import { differenceInCalendarDays, startOfDay, parse, getTime } from 'date-fns'
    import { date2timestamp, timestamp2date, formatDate } from '@/filters';

    import Form from '@/components/EventManager/Form'

    export default {
        name: 'Calendar',
        extends: Form,
        data() {
            return {
                center: false,
                matrix: {
                    day: 0, // current date start
                    steps: {
                        major: 60 * 60, // 1 Stunde
                        minor: 15 * 60, // 15 Minuten
                    },
                    min: {
                        time: getTime(parse('01.01.1970 10:00', 'dd.MM.yyyy HH:mm', new Date())) / 1000, // 10 Uhr
                        days: 1,
                    },
                    max: {
                        time: getTime(parse('01.01.1970 19:00', 'dd.MM.yyyy HH:mm', new Date())) / 1000, // 19 Uhr
                        days: 8,
                    }
                },
            }
        },
        computed: {
            slots() {
                // return _.get(this.event, 'slots') || []

                let slots = []
                const eventSlots = _.get(this.event, 'slots') || []
                eventSlots.forEach(slot => {
                    slot = _.cloneDeep(slot)

                    // fix times - timezone issue

                    const start_time = getTime(parse(
                        `01.01.1970 ${formatDate(timestamp2date(slot.start_at), 'HH:mm')}`,
                        'dd.MM.yyyy HH:mm',
                        new Date()
                    )) / 1000

                    slot.start_time = start_time

                    const end_time = getTime(parse(
                        `01.01.1970 ${formatDate(timestamp2date(slot.end_at), 'HH:mm')}`,
                        'dd.MM.yyyy HH:mm',
                        new Date()
                    )) / 1000

                    slot.end_time = end_time

                    slots.push(slot)
                })

                return slots
            },
            slot: {
                get() {
                    if (this.selections[this.$route.path] && this.selections[this.$route.path].slot)
                        return this.selections[this.$route.path].slot
                },
                set(slot) {
                    this.selectSlot({ key: this.$route.path, slot })
                }
            },
            firstDate() {
                let firstDate
                if (this.slots && this.slots.length) {
                    const sortedSlots = _.orderBy(this.slots, 'start_date', 'asc')
                    const firstSlot = sortedSlots[0]

                    if (firstSlot && firstSlot.start_date && _.isInteger(firstSlot.start_date))
                        firstDate = firstSlot.start_date
                        // firstDate = fromUnixTime(firstSlot.start_date)
                }
                return firstDate
            },
            lastDate() {
                let lastDate
                if (this.slots && this.slots.length) {
                    const sortedSlots = _.orderBy(this.slots, 'end_date', 'desc')
                    const lastSlot = sortedSlots[0]

                    if (lastSlot && lastSlot.end_date && _.isInteger(lastSlot.end_date))
                        lastDate = lastSlot.end_date
                        // lastDate = fromUnixTime(lastSlot.end_date)
                }
                return lastDate
            },
            firstTime() {
                let firstTime
                if (this.slots && this.slots.length) {
                    const sortedSlots = _.orderBy(this.slots, 'start_time', 'asc')
                    const firstSlot = sortedSlots[0]

                    if (firstSlot && firstSlot.start_time && _.isInteger(firstSlot.start_time))
                        firstTime = firstSlot.start_time
                        // firstTime = fromUnixTime(firstSlot.start_time)
                }
                return firstTime
            },
            lastTime() {
                let lastTime
                if (this.slots && this.slots.length) {
                    const sortedSlots = _.orderBy(this.slots, 'end_time', 'desc')
                    const lastSlot = sortedSlots[0]

                    if (lastSlot && lastSlot.end_time && _.isInteger(lastSlot.end_time))
                        lastTime = lastSlot.end_time
                        // lastTime = fromUnixTime(lastSlot.end_time)
                }
                return lastTime
            },
            period() {
                let period = 0
                if (_.isInteger(this.firstDate) && _.isInteger(this.lastDate)) {
                    period = differenceInCalendarDays(timestamp2date(this.lastDate), timestamp2date(this.firstDate)) + 1
                }
                return period
            },
            steps() {
                let steps = []

                let i = this.matrix.min.time
                while (i < this.matrix.max.time) {
                    if (i % this.matrix.steps.major === 0) steps.push({ type: 'major', time: timestamp2date(i) })
                    else if (i % this.matrix.steps.minor === 0) steps.push({ type: 'minor', time: timestamp2date(i) })

                    i ++
                }

                return steps
            },
            days() {
                let days = []

                let i = 0, counter = 0
                let placeholder = false
                while(i < this.period) {

                    const date = this.firstDate + (24 * 60 * 60 * i)
                    const slots = this.slots.filter(slot => slot.start_date === date)

                    let day = { slots }

                    let visible = false
                    if (counter >= this.matrix.day && counter < this.matrix.day + this.matrix.max.days) {

                        if (slots.length) placeholder = false
                        else placeholder = true

                        visible = true

                        day.visible = visible
                        day.placeholder = placeholder
                    }


                    if (slots.length || (placeholder && days[days.length - 1].placeholder === false)) {
                        if (! placeholder) {
                            // day.i = i
                            day.date = timestamp2date(date)
                        }
                        days.push(day)

                        counter ++
                    }

                    i ++
                }

                return days
            },
            ...mapGetters({
                selections: 'eventManager/selections',
            })
        },
        filters: {
            format(date, pattern = 'dd.MM.yyyy') {
                if (_.isInteger(date)) date = timestamp2date(date)
                return formatDate(date, pattern)
            }
        },
        methods: {
            getStepStyle(i) {
                const top = `${i / this.steps.length * 100}%`
                const height = `${100 / this.steps.length}%`

                return {
                    position: 'absolute',
                    height,
                    top,
                }
            },
            getSlotStyle(d, s) {
                const day = this.days[d]
                const slot = day.slots[s]

                const span = this.matrix.max.time - this.matrix.min.time

                const start = slot.start_time - this.matrix.min.time
                const end = slot.end_time - this.matrix.min.time

                const duration = end - start

                const topPercentage = start / span * 100

                const padding = 4
                const height = `calc(${duration / span * 100}% - ${2 * padding}px)`
                const top = `calc(${topPercentage}% + ${padding}px)`
                const left = `${padding}px`
                const right = `${padding}px`

                // TODO
                // find a better solution than hiding the slot
                let display = 'block'
                if (topPercentage > 100 || topPercentage < 0) display = 'none'

                let style = {
                    position: 'absolute',
                    height,
                    top,
                    left,
                    right,
                    display,
                }

                if (this.event.color) {
                    let color = Color(this.event.color)
                    // if (color.isDark()) color = color.lighten(0.4)

                    const lightness = color.lightness()
                    if (lightness < 60) color = color.lightness(60)

                    style['border-color'] = color.rgb().string()

                    // saturation
                    if (color.color[1] > 20) color.color[1] = 20
                    style['background-color'] = color.alpha(0.2).rgb().string();
                }

                return style
            },
            getSlotClass(d, s) {
                let cls = []

                const day = this.days[d]
                const slot = day.slots[s]

                if (this.slot && this.slot.id === slot.id) cls.push('selected')

                const limit = slot.member_limit || this.event.member_limit_per_slot
                if (limit > 0 && slot.bookings.length >= limit) cls.push('disabled')

                return cls
            },
            toggleSlot(slot) {
                if (this.event.booking !== 'none') {
                    if (this.slot && this.slot.id === slot.id) this.slot = undefined
                    else this.slot = slot
                }
            },
            ...mapMutations({
                selectSlot: 'eventManager/selectSlot'
            })
        },
        mounted() {
            // TODO: focus the selected date or the current date by default

            // const days = Math.min(this.period, this.matrix.max.days)
            // this.matrix.day = new Array(days)

            let space, width
            const checkIfScheduleFits = () => {
                if (this.$refs.container) {
                    const style = getComputedStyle(this.$refs.container)
                    space = this.$refs.container.clientWidth
                    space -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
                }

                if (this.$refs.schedule) {
                    const style = getComputedStyle(this.$refs.schedule)
                    width = this.$refs.schedule.clientWidth
                }

                if (space && width) {
                    if (space > width) this.center = true
                    else this.center = false
                }
            }

            window.addEventListener('resize', _.debounce(checkIfScheduleFits, 100))
            checkIfScheduleFits()
        },
    }

</script>

<style lang="sass" scoped>

    @import '~@/assets/sass/variables';
    @import "~bulma/sass/utilities/mixins";

    .event-calendar
        padding: 2rem
        height: 100vh
        min-height: 600px
        display: flex
        &.center-schedule
            justify-content: center
        .days
            // flex-grow: 1
            flex-shrink: 1
            display: flex
            position: relative
            padding-left: 40px
            .day h4
                min-width: 140px
                text-align: center
            .day h4,
            .placeholder
                white-space: nowrap
                height: 40px
                padding: 10px
            section.slots
                position: relative
                display: flex
                &:before
                    content: ''
                    position: absolute
                    left: 0
                    top: 30px
                    bottom: -10px
                    border-left: 1px solid rgba(255, 255, 255, 0.15)
                &:last-child
                    &:after
                        content: ''
                        position: absolute
                        right: 0
                        top: 30px
                        bottom: -10px
                        border-right: 1px solid rgba(255, 255, 255, 0.15)
                .day
                    display: flex
                    flex-direction: column
                    .slots
                        flex-grow: 1
                        position: relative
                        .slot
                            // color: $black
                            background: rgba(255,255,255,.2)
                            border-left: 4px solid
                            border-radius: $radius
                            border-bottom-left-radius: 0
                            border-top-left-radius: 0
                            // width: calc(100% - 8px)
                            padding: 2px 5px
                            line-height: 1.3
                            transition: background .15s ease
                            backdrop-filter: blur(2px)
                            &.disabled
                                pointer-events: none
                                color: rgba(255,255,255,.6) !important
                                cursor: not-allowed
                                .member-limit
                                    color: $orange !important
                            &.selected
                                background: rgba(70,70,70,.8) !important
                            .period
                                position: absolute
                                right: 4px
                                bottom: 2px
                                font-size: 0.7rem
                            .check
                                opacity: 0
                                transform: scale(-0.8)
                                position: absolute
                                width: 20px
                                height: 20px
                                /* right: calc(50% - 10px) */
                                /* top: calc(50% - 10px) */
                                left: 5px
                                bottom: 4px
                                transition: opacity .15s ease, transform .15s ease
                                &.visible
                                    opacity: 1
                                    transform: scale(1)
                        a.slot:hover:not(.selected)
                            background: rgba(255,255,255,.2) !important
            section.steps
                position: absolute
                top: 0
                bottom: 0
                left: 0
                right: 0
                display: flex
                flex-direction: column
                .label-placeholder
                    width: 40px
                    height: 40px
                .steps-container
                    flex-grow: 1
                    position: relative
                    .step
                        width: 100%
                        hr
                            position: absolute
                            top: 0
                            left: 0
                            height: 1px
                            margin: 0
                        &.major
                            hr
                                left: 30px
                                // width: 10px
                                right: -10px
                                background: none
                                border-bottom: 1px solid rgba(255, 255, 255, 0.5)
                            .time
                                position: absolute
                                left: 0
                                top: -.5rem
                                font-size: 1rem
                                line-height: 1
                        &.minor
                            hr
                                left: 35px
                                // width: 5px
                                right: -5px
                                background: none
                                border-bottom: 1px solid rgba(255, 255, 255, 0.2)
        .notification
            color: $black
</style>
